import Button from "@mui/material/Button";
import { useRef, useState, useEffect } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import styles from "./MobileProductCategoryDropdown.css";

interface CustomDropdownProps {
  dropDownItems: string[];
  selected: string;
  setSelected: (category: string) => void;
  clothingCategories: string[];
  categoryCounts: Record<string, number>;
}

const MobileProductCategoryDropdown: React.FC<CustomDropdownProps> = ({
  dropDownItems,
  selected,
  setSelected,
  clothingCategories,
  categoryCounts,
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showClothing, setShowClothing] = useState(false);
  const mobileRef = useRef<HTMLDivElement>(null);

  const mainOptions = dropDownItems.filter(
    (item) => !clothingCategories.includes(item)
  );

  const isClothingSelected = clothingCategories.includes(selected);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        mobileRef.current &&
        !mobileRef.current.contains(event.target as Node)
      ) {
        setMobileOpen(false);
        setShowClothing(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const renderOption = (option: string) => {
    const isSelected = selected === option;
    const isClothing = clothingCategories.includes(option);

    return (
      <div
        key={option}
        className={`px-3 py-2 cursor-pointer text-decoration-none dropdown-item-custom ${
          isSelected ? "bg-light fw-semibold" : ""
        }`}
        onClick={(e) => {
          e.stopPropagation();
          if (!isClothing) {
            setSelected(option);
            setMobileOpen(false);
            setShowClothing(false);
          }
        }}
        onMouseEnter={(e) => {
          if (!isSelected) {
            e.currentTarget.style.backgroundColor = "#f8f9fa";
          }
        }}
        onMouseLeave={(e) => {
          if (!isSelected) {
            e.currentTarget.style.backgroundColor = "transparent";
          }
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <span>{option}</span>
          {isClothing && (
            <span
              onClick={(e) => {
                e.stopPropagation();
                setShowClothing(!showClothing);
              }}
            >
              {showClothing ? (
                <KeyboardArrowDownIcon />
              ) : (
                <KeyboardArrowRightIcon />
              )}
            </span>
          )}
        </div>
      </div>
    );
  };

  const availableMainOptions = mainOptions.filter(
    (option) => !categoryCounts || categoryCounts[option] > 0
  );
  const availableClothingCategories = clothingCategories.filter(
    (cat) => !categoryCounts || categoryCounts[cat] > 0
  );

  return (
    <div
      className="col-12 d-block d-md-none"
      ref={mobileRef}
      style={{ position: "relative" }}
    >
      <Button
        sx={{ display: "flex", justifyContent: "space-between" }}
        fullWidth
        variant="outlined"
        endIcon={<KeyboardArrowDownIcon />}
        className="py-3 px-4 rounded-3 fw-semibold text-capitalize font-jakarta letter-spacing-normal dropdown-item-custom h-48"
        onClick={() => setMobileOpen(!mobileOpen)}
      >
        {isClothingSelected ? `Clothing / ${selected}` : selected}
      </Button>
      {mobileOpen && (
        <div className="position-absolute start-0 end-0 mt-2 bg-white border border-secondary rounded-3 shadow-lg z-dropdown">
          {availableMainOptions.map((option) => (
            <div
              key={option}
              className={`px-3 py-2 cursor-pointer text-decoration-none dropdown-item-custom ${
                selected === option ? "bg-light fw-semibold" : ""
              }`}
              onClick={(e) => {
                e.stopPropagation();
                setSelected(option);
                setMobileOpen(false);
              }}
            >
              {option}
            </div>
          ))}

          {availableClothingCategories.length > 0 && (
            <>
              <div
                className={`px-3 py-2 cursor-pointer text-decoration-none dropdown-item-custom ${
                  isClothingSelected ? "bg-light fw-semibold" : ""
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowClothing(!showClothing);
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span>Clothing</span>
                  {showClothing ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowRightIcon />
                  )}
                </div>
              </div>

              {showClothing && (
                <div className="border-top">
                  {availableClothingCategories.map((category) => (
                    <div
                      key={category}
                      className={`px-3 py-2 cursor-pointer text-decoration-none dropdown-item-custom ps-5 ${
                        selected === category ? "bg-light fw-semibold" : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelected(category);
                        setMobileOpen(false);
                      }}
                    >
                      {category}
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default MobileProductCategoryDropdown;
